import { get, post } from "../request-manager";
const cedarUrl = `/cedar/v1alpha1`;

// 获取机器人平台的权限
export async function getPermission({ tenantId, personId }: any) {
  return get(
    `${cedarUrl}/tenants/${tenantId}/persons/${personId}/permissions?app=`
  );
}

// 获取应用权限
export async function getApplicationPermission(params: { personId: string }) {
  return post(`/cedar/v1/person/associated/application/list`, params);
}
